import api from '../assets/api.png';
import cpp from '../assets/cpp.png';
import css from '../assets/css.png';
import email from '../assets/email.png';
import figma from '../assets/figma.png';
import flutter from '../assets/flutter.png';
import git from '../assets/git.png';
import graphql from '../assets/graphql.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import mobile from '../assets/mobile.png';
import mu5 from '../assets/mu5.png';
import node from '../assets/node.png';
import python from '../assets/python.png';
import react from '../assets/react.png';
import redux from '../assets/redux.png';
import sass from '../assets/sass.png';
import typescript from '../assets/typescript.png';
import vue from '../assets/vue.png';

import about01 from '../assets/about01.png';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';
import about04 from '../assets/about04.png';

import circle from '../assets/circle.svg';
import logo from '../assets/logo.png';
import profile from '../assets/profile.png';
import profilePhoto from '../assets/photoprofile_1.png';

import adidas from '../assets/adidas.png';
import amazon from '../assets/amazon.png';
import asus from '../assets/asus.png';
import bolt from '../assets/bolt.png';
import nb from '../assets/nb.png';
import skype from '../assets/skype.png';
import spotify from '../assets/spotify.png';

import Cprogramming from '../assets/Cprogramming.png';
import resumeIcons from '../assets/doc.gif';
import java from '../assets/java.png';
import mongodb from '../assets/mongodb.png';
import myProfile from '../assets/pitry.png';
import myProfile1 from '../assets/photo1.png';
import myProfile2 from '../assets/photo2.png';
import SQL from '../assets/MSSQL SERVER.jpg';
import dotnet from '../assets/asp.net.webp';
import cmsflogo from '../assets/cmsflogo.png';
import csharp from '../assets/c#.png';
import photoprofile2 from '../assets/photoprofile2.png';
import photoprofile3 from '../assets/photoprofile3.png';
import swe from '../assets/hacker.png';
import researcher from '../assets/researcher.png';
import researcher1 from '../assets/research.png';
import instructor from '../assets/instructor.png';
import hellowelcome from '../assets/hellowelcome.png';
import hello from '../assets/hello.gif';
import coffee from '../assets/coffee-cup.png';
import chat from '../assets/chat.png'
export default {
  SQL,
  dotnet,
  email,
  mobile,
  api,
  cpp,
  css,
  figma,
  flutter,
  git,
  graphql,
  html,
  javascript,
  mu5,
  node,
  python,
  react,
  redux,
  sass,
  typescript,
  vue,
  about01,
  about02,
  about03,
  about04,
  profile,
  circle,
  logo,
  adidas,
  amazon,
  asus,
  bolt,
  nb,
  skype,
  spotify,
  myProfile,
  myProfile1,
  myProfile2,
  mongodb,
  Cprogramming,
  java,
  resumeIcons,
  profilePhoto,
  cmsflogo,
  csharp,
  photoprofile2,
  photoprofile3,
  swe,
  researcher,
  researcher1,
  instructor,
  hellowelcome,
  hello,
  coffee,
  chat
} ;
